import React from 'react';
import marked from 'marked';



export var MarkdownView = ({content})=> {
    var html = marked(content || '');
    return <div className="markdown-view" dangerouslySetInnerHTML={{__html: html}}></div>;
};
